import React from "react";
import { SelectField, SimpleShowLayout, TextField } from "react-admin";

import { useEnumSelectChoices } from "../../../components/_helpers/useEnumSelectChoices";
import { DateTimeField } from "../../../components/fields/DateFormatField";
import { JsonTextField } from "../../../components/fields/JsonTextField";
import { AdminLogLevelType } from "../../../entities/AdminLogLevelType";
import { AdminLogModuleType } from "../../../entities/AdminLogModuleType";

export const AdminLogsDetails = (props) => {
	const adminLogLevelChoices = useEnumSelectChoices(AdminLogLevelType, "log-level");
	const adminModuleChoices = useEnumSelectChoices(AdminLogModuleType, "log-module");

	return (
		<SimpleShowLayout {...props}>
			<TextField source="id" />
			<DateTimeField source="created_at" withLocalTimeZone addLabel />
			<TextField source="order_id" />
			<SelectField source="log_level" choices={adminLogLevelChoices} />
			<SelectField source="module" choices={adminModuleChoices} />
			<TextField source="description" />
			<JsonTextField source="data" label="resources.admin-logs.fields.data" />
		</SimpleShowLayout>
	);
};
